import React from "react";
import { useRouteError, useNavigate } from "react-router-dom";
import "./ErrorPageLayout.css";

const ErrorPageLayout = () => {
  const error = useRouteError();
  const navigate = useNavigate(); // Hook for navigation

  // Function to navigate to the homepage
  const goToHomepage = () => {
    navigate("/"); // Navigates to the homepage ("/")
  };

  console.log("here is error", error);

  return (
    <div className="error-page">
      <div className="container error-container">
        <h1 className="error-heading">
          OOPS! Looks like something unexpected happened
        </h1>
        <h2 className="error-subheading">
          Try to refresh the page or go back to homepage.
        </h2>

        <div className="inner-container-first error-details-container">
          <h3 className="error-details-heading">Here are Error details :-</h3>
          <p className="error-message">{error?.status || "Unknown Error"}</p>
          <p className="error-message">
            {error?.statusText ||
              error?.message ||
              "An unknown error occurred."}
          </p>
        </div>

        {/* Button to go to the homepage */}
        <button className="go-home-button" onClick={goToHomepage}>
          Go to Homepage
        </button>
      </div>
    </div>
  );
};

export default ErrorPageLayout;
